export default __webpack_public_path__ + "static/media/levelBackground.4a894a30.svg";